'use strict';

/**
 *
 * @name: wechat
 *
 */

function NnCloseModalButtonDirective(
  $timeout,
  nnModalsService
) {

  'ngInject';

  return {
    restrict: 'E',
    scope: {
      modalName: '=',
      beforeClose: '&'
    },
    replace: true,
    template: '<div class="modal-close" data-ng-mouse-over="$root.isMobileDevice ? closeModal : null" data-ng-click="closeModal();"></div>',
    link: function(scope) {

      /*
       *
       * @CONFIG
       *
       */

      /*
       *
       * @PUBLIC
       *
       */

      scope.closeModal = function() {

        if(scope.beforeClose && typeof scope.beforeClose === 'function'){

          $timeout(function(){
            scope.beforeClose()
            nnModalsService.hideModal(scope.modalName)
          })

          return
        }

        nnModalsService.hideModal(scope.modalName)
      };

      /*
       *
       * @PRIVATE
       *
       */

      /*
       *
       * @INIT
       *
       */
    }
  };
}

export default NnCloseModalButtonDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-close-modal-button.directive.js